import React, { useContext } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import propTypes from 'prop-types'
import UserThemeContext from '../../../context/UserTheme'

import v from '../../../styles/modules/_variables.scss'
import 'react-tooltip/dist/react-tooltip.css'
import './Tooltip.scss'

// Import Sass variable(s)
const { timing } = v
const timingNumber = Number(timing)

const Tooltip = ({ id }) => {
  const [theme] = useContext(UserThemeContext)

  return (
    <ReactTooltip
      anchorId={id}
      className='react-tooltip'
      delayHide={timingNumber}
      delayShow={300}
      noArrow
      offset={4}
      place='bottom'
      variant={theme}
    />
  )
}

Tooltip.propTypes = {
  id: propTypes.string.isRequired,
}

export default Tooltip
